import React from 'react'
import { InboxSuccess } from './Inbox/InboxSuccess'
import { InboxUpsellBody, InboxUpsellFeatures } from './Inbox/InboxUpsell'
import { ProfessionalSuccess } from './Professional/ProfessionalSuccess'
import { InboxTimeline } from './Inbox/InboxTimeline'
import { DeltaTrialTimelineProps } from './Timeline/DeltaTrialTimeline'
import { ProfessionalTimeline } from './Professional/ProfessionalTimeline'
import { ProcessDocumentUpsellBody, ProcessDocumentUpsellFeatures } from './ProcessDocument/ProcessDocumentUpsell'
import { ProcessDocumentTimeline } from './ProcessDocument/ProcessDocumentTimeline'
import { ProcessDocumentSuccess } from './ProcessDocument/ProcessDocumentSuccess'
import { FormTemplateUpsellBody, FormTemplateUpsellFeatures } from './FormTemplate/FormTemplateUpsell'
import { FormTemplateTimeline } from './FormTemplate/FormTemplateTimeline'
import { FormTemplateSuccess } from './FormTemplate/FormTemplateSuccess'
import { BusinessEventsUpsellBody, BusinessEventsUpsellFeatures } from './BusinessEvents/BusinessEventsUpsell'
import { BusinessEventsTimeline } from './BusinessEvents/BusinessEventsTimeline'
import { BusinessEventsSuccess } from './BusinessEvents/BusinessEventsSuccess'
import { ZapierIntegrationUpsellBody, ZapierIntegrationUpsellFeatures } from './ZapierIntegration/ZapierIntegration'
import { ZapierIntegrationTimeline } from './ZapierIntegration/ZapierIntegrationTimeline'
import { ZapierIntegrationSuccess } from './ZapierIntegration/ZapierIntegrationSuccess'
import { getProfessionalPlanId, getUltimatePlanId } from '../planConstants'

export interface DeltaTrialFeature {
  id: string
  name: string
  planId: string
  calendly: string
  UpsellBody: React.ComponentType
  UpsellFeatures: React.ComponentType
  DeltaTrialTimeline: React.ComponentType<DeltaTrialTimelineProps>
  DeltaTrialSuccess: React.ComponentType
}

export const DELTA_TRIAL_FEATURES: { [key: string]: DeltaTrialFeature } = {
  inbox: {
    id: 'inbox',
    name: 'Inbox',
    planId: getUltimatePlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/email-hub-demo?utm_source=in-app',
    UpsellBody: InboxUpsellBody,
    UpsellFeatures: InboxUpsellFeatures,
    DeltaTrialTimeline: InboxTimeline,
    DeltaTrialSuccess: InboxSuccess,
  },
  processDocument: {
    id: 'processDocument',
    name: 'Document Intelligence',
    planId: getUltimatePlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/ultimate-plan-demo-ia',
    UpsellBody: ProcessDocumentUpsellBody,
    UpsellFeatures: ProcessDocumentUpsellFeatures,
    DeltaTrialTimeline: ProcessDocumentTimeline,
    DeltaTrialSuccess: ProcessDocumentSuccess,
  },
  professional: {
    id: 'professional',
    name: 'Professional features',
    planId: getProfessionalPlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/zocks-professional?utm_source=in-app',
    UpsellBody: () => null,
    UpsellFeatures: () => null,
    DeltaTrialTimeline: ProfessionalTimeline,
    DeltaTrialSuccess: ProfessionalSuccess,
  },
  formTemplate: {
    id: 'formTemplate',
    name: 'Document Fill',
    planId: getUltimatePlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/ultimate-plan-demo-ia',
    UpsellBody: FormTemplateUpsellBody,
    UpsellFeatures: FormTemplateUpsellFeatures,
    DeltaTrialTimeline: FormTemplateTimeline,
    DeltaTrialSuccess: FormTemplateSuccess,
  },
  businessEvents: {
    id: 'businessEvents',
    name: 'Client Signals',
    planId: getProfessionalPlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/zocks-professional?utm_source=in-app',
    UpsellBody: BusinessEventsUpsellBody,
    UpsellFeatures: BusinessEventsUpsellFeatures,
    DeltaTrialTimeline: BusinessEventsTimeline,
    DeltaTrialSuccess: BusinessEventsSuccess,
  },
  zapierIntegration: {
    id: 'zapierIntegration',
    name: 'the Zapier Integration',
    planId: getUltimatePlanId(),
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/ultimate-plan-demo-ia',
    UpsellBody: ZapierIntegrationUpsellBody,
    UpsellFeatures: ZapierIntegrationUpsellFeatures,
    DeltaTrialTimeline: ZapierIntegrationTimeline,
    DeltaTrialSuccess: ZapierIntegrationSuccess,
  },
}
